import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { getPlatformNative } from "shared/lib/get-platform-native"
import { Header } from "shared/ui/header/ui"
import { Main } from "widgets/main/ui"
import { DevelopmentServices } from "widgets/development-services"
import { Slider } from "widgets/slider/ui"
import { useApp } from "./hooks/use-app"
import { Process } from "widgets/process/ui"
import { Projects } from "widgets/projects"
// import { Teachers } from "widgets/teachers/ui"
import { Courses } from "widgets/courses/ui"
import { Feedback } from "widgets/feedback/ui"
import { Footer } from "widgets/footer/ui"
import { Popouts } from "widgets/app/popouts"
import { EducationInfo } from "widgets/education-info"
import { MobileMenuProvider } from "shared/contexts/mobile-menu-context"

const _platform = getPlatformNative()

const HomePage = () => (
    <>
        <Main />
        <DevelopmentServices />
        <Slider />
        <Courses />
        <Process />
        <Projects />
        <Feedback />
        {/* <Teachers /> */}
        <Footer />
    </>
);

const AppContent = () => {
    const location = useLocation();
    const isHackathonPage = location.pathname === '/hackathon';

    return (
        <div className={`app ${_platform}`}>
            <Popouts />
            {!isHackathonPage && <Header />}
                    
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/education-info" element={<EducationInfo />} />
            </Routes>
        </div>
    );
};

const App = () => {

    console.log('App')
    console.log('Version 2.0.0 - Ансариум: Разработка и Образование')

    useApp()

    return (
        <MobileMenuProvider>
            <Router>
                <AppContent />
            </Router>
        </MobileMenuProvider>
    )
}
export default App